import { useCallback, useState } from 'react'
import { V2L3FeedbackModal } from '@fusion-advantage/formrender'
import { useAppDispatch, useAppSelector } from '../../../redux/hooks'
import { AppModal, dismissAppModal } from '../../../redux/appSlice'
import { apiDashboardSubmitFeedback } from '../../../redux/apithunk/apiDashboard'

export const LxFeedbackModal = () => {
	const dispatch = useAppDispatch()
	const loading = useAppSelector(state => state.app.ldng.apiDashboardSubmitFeedback) ?? false
	const simulateOffline = useAppSelector(state => state.app.simulateOffline)
	const submittedDt = new Date().toISOString()

	const [overallExperience, setOverallExperience] = useState(0) 
	const [easeOfNavigation, setEaseOfNavigation] = useState(0) 
	const [productQuality, setProductQuality] = useState(0)
	const [whatWorked, setWhatWorked] = useState('')
	const [generalFeedback, setGeneralFeedback] = useState('')

	const handleSubmitClick = useCallback(async () => {
		// we only want to allow feedback submission if at least one field has been filled out
		if(overallExperience || easeOfNavigation || productQuality || whatWorked || generalFeedback) {
			if(simulateOffline) {
				if(!confirm('Currently simulating offline— restore connectivity?')) {
					return
				}
			}
			const r = await dispatch(apiDashboardSubmitFeedback({
				submittedDt,
				overallExperience,
				easeOfNavigation,
				productQuality,
				whatWorked,
				generalFeedback,
			}))
			if(r.isErr()) {
				alert('Unable to submit feedback— please ensure your device is online, and try again.')
			} else {
				alert('Your feedback has been received, thank you!')
				dispatch(dismissAppModal(AppModal.Feedback))
			}
		}
	}, [overallExperience, easeOfNavigation, productQuality, whatWorked, generalFeedback, simulateOffline, dispatch])

	return (
		<V2L3FeedbackModal
			loading={loading}
			onSubmit={handleSubmitClick}
			onDismissClick={() => dispatch(dismissAppModal(AppModal.Feedback))}
			overallExperience={overallExperience}
			easeOfNavigation={easeOfNavigation}
			productQuality={productQuality}
			whatWorked={whatWorked}
			generalFeedback={generalFeedback}
			handleChangeOverallExperience={(value) => setOverallExperience(value)}
			handleChangeEaseOfNavigation={(value) => setEaseOfNavigation(value)}
			handleChangeProductQuality={(value) => setProductQuality(value)}
			handleChangeWhatWorked={(e) => setWhatWorked(e.target.value)}
			handleChangeGeneralFeedback={(e) => setGeneralFeedback(e.target.value)}
		/>
	)
}
